var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7776 40.8138L9.5 40.6198L9.53856 39.8437L12.7391 40.0377V32.4705H9.73136V31.6944H12.7391V25.8735L9.6928 26.3392L9.57712 25.5631L12.7391 25.0974V18.4228L34.7185 12.8347V12.7959H34.7571H34.7956V12.8347L51.2224 18.8496V19.5481V24.7093L54.3843 25.2914L54.2301 26.0675L51.2224 25.4855V31.7332H54.5V32.5093H51.2224V39.572L54.3843 39.184L54.4614 39.9601L51.2224 40.3481V47.9541L34.9113 51.7571V51.7959H34.8342L34.7571 51.8347V51.7959L12.8162 48.2257V40.8138H12.7776ZM14.7057 40.1541L34.7185 41.3571V32.4705H14.7057V40.1541ZM14.7057 31.6944H34.7185V22.4974L14.7057 25.5631V31.6944ZM14.7057 19.9362V24.7869L34.7185 21.7213V14.8138L14.7057 19.9362ZM49.2943 20.2078L36.6465 15.5511V21.8765L49.2558 24.2825V20.2078H49.2943ZM49.2943 25.0974L36.6851 22.6914V31.6944H49.2943V25.0974ZM49.2943 32.4705H36.6851V41.2795L49.2943 39.8049V32.4705ZM49.2943 46.4407V40.581L36.6851 42.0556V49.3511L49.2943 46.4407ZM34.7185 49.8168V42.1332L14.7057 40.9302V46.5571L34.7185 49.8168Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 39,
    fill: "currentcolor",
    transform: "matrix(-1 0 0 1 54.5 12.7959)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.e4020607.svg";
export { ForwardRef as ReactComponent };